module.exports = __webpack_public_path__ + "img/domain-08.833e89ec.png";